import React, { useEffect, useState } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { closeModal } from 'reducers/modals';
// components
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import Modal from 'components/Modal';
import Button from 'components/Button';
import ReactSelect from 'components/Select/ReactSelect';
import SingleDatePicker from 'components/DatePicker/SingleDatePicker/SingleDatePicker';
// endpoints
import { getFeedDeliveriesFarmGroups, openBinCycle } from 'endpoints/feedDeliveries';
// utils
import { toastResponseErrors } from 'utils/responseErrorsHelper';

const OpenBinModal = ({ farmId, bin, onSuccess, closeModal }) => {
  const [groups, setGroups] = useState([]);
  const [pigGroupId, setPigGroupId] = useState(null);
  const [openedOn, setOpenedOn] = useState(moment());
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    getFeedDeliveriesFarmGroups(farmId, { per_page: 100 })
      .then((response) => setGroups(response.resources || []))
      .catch(toastResponseErrors);
  }, [farmId]);

  const handleSubmit = async () => {
    setIsSaving(true);
    try {
      await openBinCycle(farmId, bin.id, {
        opened_on: openedOn.format('YYYY-MM-DD'),
        pig_group_id: pigGroupId,
      });
      closeModal();
      onSuccess();
    } catch (error) {
      toastResponseErrors(error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal
      title={<FormattedMessage id="component.feedDeliveries.openBinTitle" values={{ binName: bin.name }} />}
      className="BinCycleModal"
    >
      <section className="modal-body">
        <div className="form-row">
          <span className="input-label"><FormattedMessage id="general.group" /></span>
          <ReactSelect
            placeholder={<FormattedMessage id="general.selectGroup" />}
            options={groups}
            valueKey="id"
            labelKey="name"
            value={pigGroupId}
            onChange={(option) => setPigGroupId(option ? option.id : null)}
            noInputMargin
          />
        </div>

        <div className="form-row">
          <span className="input-label"><FormattedMessage id="component.feedDeliveries.binOpenDate" /></span>
          <SingleDatePicker
            inputId="binOpenDateInput"
            className="date-input"
            date={openedOn}
            onDateChange={setOpenedOn}
            isOutsideRange={(day) => day.isAfter(moment(), 'day')}
          />
        </div>
      </section>

      <section className="modal-footer text-right">
        <Button className="margin-right-1" onClick={closeModal} disabled={isSaving}>
          <FormattedMessage id="general.button.cancel" />
        </Button>
        <Button primary onClick={handleSubmit} disabled={isSaving || !pigGroupId || !openedOn}>
          <FormattedMessage id="component.feedDeliveries.openBin" />
        </Button>
      </section>
    </Modal>
  );
};

OpenBinModal.propTypes = {
  farmId: T.number.isRequired,
  bin: T.object.isRequired,
  onSuccess: T.func.isRequired,
  closeModal: T.func.isRequired,
};

export default connect(null, { closeModal })(OpenBinModal);
